import ContentLoader from "@rio-cloud/rio-uikit/ContentLoader";
import { DashboardFilter } from "../../types/dashboard";
import { useIsTreeReady } from "@store/tmsAssetTree/tmsAssetTreeSlice";
import { useT } from "@hooks";

interface ISelectedFiltersProps {
  requestFilters: DashboardFilter;
}

const COUNTER_LOADER_HEIGHT = 16;
const COUNTER_LOADER_WIDTH = 24;

const FILTER_ITEMS = [
  { key: "branch", icon: "rioglyph-building" },
  { key: "segment", icon: "rioglyph-role-management" },
  { key: "clientSupplier", icon: "rioglyph-transfer" },
  { key: "vehicle", icon: "rioglyph-truck" },
  { key: "driver", icon: "rioglyph-driver" },
];

export const SelectedFiltersSkeleton = () => {
  const t = useT();

  return (
    <div className="display-flex align-items-center flex-wrap gap-10">
      <p className="margin-0 text-size-14 text-bold">{t("selectedFilters.title")}</p>
      <div className="display-flex align-items-center flex-wrap gap-10 gap-20-sm">
        {FILTER_ITEMS.map((filter) => (
          <div key={filter.key} className="display-flex align-items-center gap-5">
            <span className={`rioglyph ${filter.icon} text-size-16 margin-top-2`}></span>
            <p className="margin-0 text-size-16">
              <ContentLoader
                className="skeleton-on-light-bg"
                height={COUNTER_LOADER_HEIGHT}
                width={COUNTER_LOADER_WIDTH}
              />
            </p>
            <p className="margin-0 text-size-16">{t(`selectedFilters.${filter.key}.plural`)}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

const SelectedFilters = ({ requestFilters }: ISelectedFiltersProps) => {
  const t = useT();
  const isTreeReady = useIsTreeReady();

  const branchs = requestFilters?.branchIds?.length ?? 0;
  const segments = requestFilters?.segmentIds?.length ?? 0;
  const clients = (requestFilters?.clientIds?.length ?? 0) + (requestFilters?.supplierIds?.length ?? 0);
  const vehicles = requestFilters?.vehicleIds?.length ?? 0;
  const drivers = requestFilters?.driverIds?.length ?? 0;

  const counts: Record<string, number> = {
    branch: branchs,
    segment: segments,
    clientSupplier: clients,
    vehicle: vehicles,
    driver: drivers,
  };

  const checkingAvailableFilters = () => !!(branchs || segments || clients || vehicles || drivers);

  if (!isTreeReady) return <SelectedFiltersSkeleton />;

  return (
    <div className="display-flex align-items-center flex-wrap gap-10">
      {checkingAvailableFilters() ? (
        <>
          <p className="margin-0 text-size-14 text-bold">{t("selectedFilters.title")}</p>
          <div className="display-flex align-items-center flex-wrap gap-10 gap-20-sm">
            {FILTER_ITEMS.map((filter) =>
              counts[filter.key] ? (
                <div key={filter.key} className="display-flex align-items-center gap-5">
                  <span className={`rioglyph ${filter.icon} text-size-16 margin-top-2`}></span>
                  <p className="margin-0 text-size-16">{counts[filter.key]}</p>
                  <p className="margin-0 text-size-16">
                    {counts[filter.key] === 1
                      ? t(`selectedFilters.${filter.key}.singular`)
                      : t(`selectedFilters.${filter.key}.plural`)}
                  </p>
                </div>
              ) : null
            )}
          </div>
        </>
      ) : null}
    </div>
  );
};

export default SelectedFilters;
